import vTab from "./v-tab.vue";
import vTabs from "./v-tabs.vue";

export default Vue => {
  Vue.component("v-tabs", vTabs);
  Vue.component("v-tab", vTab);
};
